
// @ts-nocheck
declare var gGDPR_logoURL: string;

declare var gGDPR_privacyPolicyURL: string;

import { Emit, Component, Prop, Vue } from "vue-facing-decorator";
import SensitiveDataList from './SensitiveDataList.vue';
import ConsentItem from './ConsentItem.vue';

import { UsCa as UsCaV1 } from '@iabgpp/cmpapi' 
import { updateCMPCalifornia } from './updateCMPFuncs.js'

@Component({
  components: {
    SensitiveDataList,
    ConsentItem
  },
  props: {
    cmpApi: Object,
  },  

})

export default class LayerStateCalifornia extends Vue {

	privacyPageURL = "";
  forcedFixedPosition = false;
  logo_URL = typeof gGDPR_logoURL  == "string" ? gGDPR_logoURL : "";

  consentToSharing = true;
  consentToTargeting = true;
  sectionName = UsCaV1.NAME;
  sectionID = UsCaV1.ID;
  dirty = false;

  sensitiveLeadText = "Consent to the Use or Disclosure of the Consumer's Sensitive Personal Information:";
  sensitiveFeatures = [
    { position: 1, description: "Which Reveals a Consumer's Social Security, Driver's License, State Identification Card, or Passport Number." },
    { position: 2, description: "Which Reveals a Consumer's Account Log-In, Financial Account, Debit Card, or Credit Card Number in Combination with Any Required Security or Access Code, Password, or Credentials Allowing Access to an Account." },
    { position: 3, description: "Which Reveals a Consumer's Precise Geolocation." },
    { position: 4, description: "Which Reveals a Consumer's Racial or Ethnic Origin, Religious or Philosophical Beliefs, or Union Membership." },
    { position: 5, description: "Which Reveals the contents of a Consumer's Mail, Email, and Text Messages unless You Are the Intended Recipient of the Communication." },
    { position: 6, description: "Which Reveals a Consumer's Genetic Data." },
    { position: 7, description: "Consisting of Biometric Information tor the Purpose of Uniquely Identifying a Consumer." },
    { position: 8, description: "Consisting of Personal Information Collected and Analyzed Concerning a Consumer's Health." },
    { position: 9, description: "Consisting of Personal Information Collected and Analyzed Concerning a Consumer's Sex Life or Sexual Orientation." }
  ];

  mounted(): void {
    console.log("California Mounted");
    this.privacyPageURL = typeof gGDPR_privacyPolicyURL  == "string" ? gGDPR_privacyPolicyURL : "";

    if ( this.cmpApi.hasSection( this.sectionName ) ) {
      this.consentToSharing = this.cmpApi.getFieldValue(this.sectionName, 'SaleOptOut' ) == 2  ? true : false;
      this.consentToTargeting = this.cmpApi.getFieldValue(this.sectionName, 'SharingOptOut') == 2  ? true : false;
    } else {
      updateCMPCalifornia( true, this.cmpApi, this.consentToSharing, this.consentToTargeting )
    }  
  }

  sensitiveDataChange( consentArray ) {
    console.log("LayerStateCalifornia: sensitiveDataChange(): event=", consentArray);
    this.dirty = true;
  } 

  @Emit('changeViewEvent')
	saveSettingsClick(consentToAll : Boolean): string {
    if ( consentToAll)  {
      this.consentToSharing = true;
      this.consentToTargeting = true;
    }

		updateCMPCalifornia( consentToAll, this.cmpApi, this.consentToSharing, this.consentToTargeting )
    this.cmpApi.fireEvent( "sectionChanged", this.sectionName);
    return 'close'
	}
  
}
